import { createContext } from 'react';
export const SessionContext = createContext(undefined);
SessionContext.displayName = 'SessionContext';
//# sourceMappingURL=SessionContext.js.map